import * as Sentry from '@sentry/react'
import { jwtDecode } from 'jwt-decode'

import { isTokenValid } from '@/utils/validators/jwt'

import { getAccessToken } from './token-storage'

export interface AccessTokenCompany {
  _id: string
  is_admin: boolean
}

export interface AccessTokenClaims {
  sub: string
  email: string
  is_root: boolean
  companies: AccessTokenCompany[]
  exp: number
}

type RawAccessTokenClaims = {
  sub?: string
  email?: string
  is_root?: boolean
  companies?: AccessTokenCompany[]
  exp?: number
}

export const decodeAccessToken = (): AccessTokenClaims | null => {
  const token = getAccessToken()
  if (!token || !isTokenValid(token)) return null

  try {
    const decoded = jwtDecode<RawAccessTokenClaims>(token)
    if (!decoded.sub || !decoded.email) return null

    return {
      sub: decoded.sub,
      email: decoded.email,
      is_root: decoded.is_root ?? false,
      companies: decoded.companies ?? [],
      exp: decoded.exp ?? 0,
    }
  } catch {
    Sentry.captureException(new Error('Failed to decode access token'))
    return null
  }
}
